<nz-layout>
    <nz-content class="table-container">
        <div class="table-wrapper" (scroll)="onScroll($event)" (scrollend)="onScrollEnd($event)" #scroll>
            <table-pro [config]="config!" [currentPage]="1" [currentPageSize]="1000" [tableData]="[]" [stickyTop]="40"
                (queryPanelStateChange)="queryPanelStateChange($event)" (resetClick)="resetSearch()"
                (searchClick)="searchClick($event)">

                <div class="grid overview" overview>
                    <div class="row">
                        <div class="column no-border" [style.width]="'100px'">
                            <select class="color-primary" (ngModelChange)="onSectionChange()" [(ngModel)]="jgSectionId">
                                <option *ngFor="let item of jgSectionList" [value]="item.id">{{item.name}}</option>
                            </select>
                        </div>
                        <div class="column no-border" [style.width]="'46rem'" [style.justifyContent]="'flex-start'">
                            <wbs-jg-cascader [unitCascaderValue]="unitCascaderValue" class="color-primary"
                                [style.width]="46 + 'rem'" [filterSectionIds]="constructionSectionIds"
                                (unitCascaderValueChange)="onUnitCascaderValueChange($event)">
                            </wbs-jg-cascader>
                        </div>
                        <div class="column no-border" [style.width]="'10rem'">
                            <b>交工实体检测视图</b>
                        </div>
                    </div>

                </div>

                <div body>
                    <table [style.left]="0" [style.width]="totalWidth + 'px'">
                        <colgroup>
                            <col span="1" [style.width]="(56 * 100 / totalWidth) + '%'">
                            <col span="1" *ngFor="let col of config?.columns ?? []"
                                [style.width]="(col.width * 100 / totalWidth) + '%'">
                        </colgroup>

                        <tr class="{{index < recordTable.length - 1 && (item.fullName + (item.partitionCode ?? '')) !== (recordTable[index + 1].fullName + (item.partitionCode ?? '')) ? 'border-bottom-black' : ''}}"
                            *ngFor="let item of recordTable ?? []; let index = index;">
                            <td [style.textAlign]="'center'">
                                {{index + (pager.pageIndex - 1) * pager.pageSize + 1}}</td>

                            <td class="border-bottom-black background-white"
                                *ngIf="(item.dwCode || item.sectionItemIndex! === 0) && sliceCount === 0"
                                [rowSpan]="item.dwSpan ?? 1">
                                <span class="color-light">{{item.dwCode}}</span> {{item.dwName}}
                            </td>
                            <td class="border-bottom-black background-white"
                                *ngIf="(item.subDwCode || item.sectionItemIndex! === 1) && sliceCount <= 1"
                                [rowSpan]="item.subDwSpan ?? 1">
                                <span class="color-light">{{item.subDwCode}}</span> {{item.subDwName}}
                            </td>
                            <td class="border-bottom-black background-white"
                                *ngIf="(item.fbCode || item.sectionItemIndex! === 2) && sliceCount <= 2"
                                [rowSpan]="item.fbSpan ?? 1">
                                <span class="color-light">{{item.fbCode}}</span> {{item.fbName}}
                            </td>
                            <td class="border-bottom-black background-white"
                                *ngIf="(item.subFbCode || item.sectionItemIndex! === 3) && sliceCount <= 3"
                                [rowSpan]="item.subFbSpan ?? 1">
                                <b *ngIf="!!item.subFbSpan"> <span class="color-light">{{item.subFbCode}}</span>
                                    {{item.subFbName}}</b>

                                <format-data *ngIf="!item.subFbSpan" contentStr="{{item.subFbCode}} {{item.subFbName}}"
                                    [patternStr]="'B@@E+108@@C7f7f7f0,2'">
                                </format-data>
                            </td>
                            <td class="border-bottom-black background-white"
                                *ngIf="(item.fxCode || item.sectionItemIndex! === 4) && sliceCount <= 4"
                                [rowSpan]="item.fxSpan ?? 1">
                                <format-data contentStr="{{item.fxCode}} {{item.fxName}}"
                                    [patternStr]="'B@@E+108@@C7f7f7f0,2'">
                                </format-data>
                            </td>
                            <td class="{{isLM ? 'background-white border-bottom-black' : 'border-right-black'}}"
                                *ngIf="isLM && item.sectionCode || !isLM" [rowSpan]="item.sectionSpan ?? 1">
                                <p class="ellipsis" dPopover [content]="item.sectionCode + ' ' + item.sectionName"
                                    [trigger]="'hover'" [position]="['bottom','top', 'right',  'left']"
                                    [controlled]="(item.sectionCode + ' ' + item.sectionName).length > 25"
                                    [popoverStyle]="{ backgroundColor: 'white', color: '#1C53D9' }"
                                    [appendToBody]="true">
                                    <span class="color-grey">{{item.sectionCode}}</span> {{item.sectionName}}
                                </p>
                            </td>
                            <td class="{{isLM ? 'background-white border-bottom-black' : ''}}"
                                *ngIf="isLM && item.sectionCode || !isLM" [rowSpan]="item.sectionSpan ?? 1">
                                <format-data [contentStr]="item.projectTypeName ?? ''" [patternStr]="'E+134'">
                                </format-data>
                                <br>
                                <span class="color-grey">{{item.projectTypeCode}}</span>
                            </td>
                            <td class="color-light text-center {{isLM ? 'background-white border-bottom-black' : ''}}"
                                *ngIf="isLM && item.sectionCode || !isLM" [rowSpan]="item.sectionSpan ?? 1">
                                {{item.constructionOrgName}}
                            </td>

                            <td class="text-center {{isLM ? 'background-white border-bottom-black' : ''}}"
                                *ngIf="isLM && item.code" [rowSpan]="item.codeSpan ?? 1">
                                {{item.code}}
                            </td>
                            <td class="{{isLM ? 'background-white border-bottom-black border-right-black' : ''}}"
                                *ngIf="isLM && item.code" [rowSpan]="item.codeSpan ?? 1">
                                <p *ngIf="!!item.mileage" class="ellipsis" dPopover [content]="item.mileage"
                                    [trigger]="'hover'" [position]="['bottom','top', 'right',  'left']"
                                    [controlled]="item.mileage.length > 16"
                                    [popoverStyle]="{ backgroundColor: 'white', color: '#1C53D9' }"
                                    [appendToBody]="true">
                                    {{item.mileage}}
                                </p>
                            </td>
                            <td class="color-light {{isLM ? 'background-white border-bottom-black border-right-black' : ''}}"
                                *ngIf="isLM && item.code || !isLM" [rowSpan]="item.codeSpan ?? 1"
                                [style.textAlign]="'center'">
                                <span *ngIf="item.status" class="{{ProjectSectionUnitStatusColorMap[item.status]}}">
                                    {{ProjectSectionUnitStatusMap[item.status]}}
                                </span>
                            </td>
                            <td class="color-light {{isLM ? 'background-white border-bottom-black border-right-black' : ''}}"
                                *ngIf="isLM && item.code || !isLM" [rowSpan]="item.codeSpan ?? 1"
                                [style.textAlign]="'center'">
                                <span *ngIf="item.constructionFormCompleted" class="color-success">齐全</span>
                                <span *ngIf="!item.constructionFormCompleted" class="color-primary">
                                    {{item.constructionFormUploadedCount}}
                                </span>
                                <span *ngIf="!item.constructionFormCompleted" class="color-grey">
                                    /
                                </span>
                                <span *ngIf="!item.constructionFormCompleted">
                                    {{item.constructionFormCount}}
                                </span>
                            </td>
                            <td class="color-light {{isLM ? 'background-white border-bottom-black border-right-black' : ''}}"
                                *ngIf="isLM && item.code || !isLM" [rowSpan]="item.codeSpan ?? 1"
                                [style.textAlign]="'center'">
                                <span *ngIf="item.superviseRecordFormCompleted" class="color-success">齐全</span>
                                <span *ngIf="!item.superviseRecordFormCompleted" class="color-primary">
                                    {{item.superviseRecordFormUploadedCount}}
                                </span>
                                <span *ngIf="!item.superviseRecordFormCompleted" class="color-grey">
                                    /
                                </span>
                                <span *ngIf="!item.superviseRecordFormCompleted">
                                    {{item.superviseRecordFormCount}}
                                </span>
                            </td>
                            <td>
                                {{item.jgInspItemName}}
                            </td>
                            <td class="{{ProjectSectionUnitJgStatusColorMap[item.jgStatus!]}}"
                                [style.textAlign]="'center'">
                                {{ProjectSectionUnitJgStatusMap[item.jgStatus!]}}
                            </td>
                            <td [style.textAlign]="'center'">
                                <span (click)="sign(item.jgRfiWorkFlowKey!)" class="clickable"
                                    [style.color]="getColor(item.jgRfiStatus!)">
                                    {{item.jgRfiName}}
                                </span>
                            </td>
                            <td [style.textAlign]="'center'">
                                <span (click)="sign(item.jgHirWorkFlowKey!)" class="clickable color-primary">
                                    {{item.jgHirName}}
                                </span>
                            </td>
                            <td class="editable">
                                <format-data *ngIf="recordFakeTable.length === 0"
                                    [contentStr]="item.comment?.toString() ?? ''" [patternStr]="'E+118'">
                                </format-data>
                            </td>
                        </tr>

                    </table>

                    <!-- 骨架行 -->
                    <table class="fake {{scrollIndex % 2 === 1 ? 'odd' : ''}}" *ngIf="recordFakeTable.length > 0"
                        [style.left]="0" [style.width]="totalWidth + 'px'"
                        [style.top]="(scrollTop + (isOpen ? 136 : 72)) + 'px'">
                        <colgroup>
                            <col span="1" [style.width]="(56 * 100 / totalWidth) + '%'">
                            <col span="1" *ngFor="let col of config?.columns ?? []"
                                [style.width]="(col.width * 100 / totalWidth) + '%'">
                        </colgroup>
                        <tr class="{{index < recordFakeTable.length - 1 && (item.fullName + (item.partitionCode ?? '')) !== (recordFakeTable[index + 1].fullName + (item.partitionCode ?? '')) ? 'border-bottom-black' : ''}}"
                            *ngFor="let item of recordFakeTable; let index = index;">
                            <td [style.textAlign]="'center'">
                                {{index + (pager.pageIndex - 1) * pager.pageSize + scrollIndex + 1}}</td>

                            <td class="border-bottom-black background-white"
                                *ngIf="(item.dwCode || item.sectionItemIndex! === 0) && sliceCount === 0"
                                [rowSpan]="item.dwSpan ?? 1">
                                <span class="color-light">{{item.dwCode}}</span> {{item.dwName}}
                            </td>
                            <td class="border-bottom-black background-white"
                                *ngIf="(item.subDwCode || item.sectionItemIndex! === 1) && sliceCount <= 1"
                                [rowSpan]="item.subDwSpan ?? 1">
                                <span class="color-light">{{item.subDwCode}}</span> {{item.subDwName}}
                            </td>
                            <td class="border-bottom-black background-white"
                                *ngIf="(item.fbCode || item.sectionItemIndex! === 2) && sliceCount <= 2"
                                [rowSpan]="item.fbSpan ?? 1">
                                <span class="color-light">{{item.fbCode}}</span> {{item.fbName}}
                            </td>
                            <td class="border-bottom-black background-white"
                                *ngIf="(item.subFbCode || item.sectionItemIndex! === 3) && sliceCount <= 3"
                                [rowSpan]="item.subFbSpan ?? 1">
                                <b *ngIf="!!item.subFbSpan"> <span class="color-light">{{item.subFbCode}}</span>
                                    {{item.subFbName}}</b>

                                <format-data *ngIf="!item.subFbSpan" contentStr="{{item.subFbCode}} {{item.subFbName}}"
                                    [patternStr]="'B@@E+108@@C7f7f7f0,2'">
                                </format-data>
                            </td>
                            <td class="border-bottom-black background-white"
                                *ngIf="(item.fxCode || item.sectionItemIndex! === 4) && sliceCount <= 4"
                                [rowSpan]="item.fxSpan ?? 1">
                                <format-data contentStr="{{item.fxCode}} {{item.fxName}}"
                                    [patternStr]="'B@@E+108@@C7f7f7f0,2'">
                                </format-data>
                            </td>
                            <td class="{{isLM ? 'background-white border-bottom-black' : 'border-right-black'}}"
                                *ngIf="isLM && item.sectionCode || !isLM" [rowSpan]="item.sectionSpan ?? 1">
                                <p class="ellipsis" dPopover [content]="item.sectionCode + ' ' + item.sectionName"
                                    [trigger]="'hover'" [position]="['bottom','top', 'right',  'left']"
                                    [controlled]="(item.sectionCode + ' ' + item.sectionName).length > 25"
                                    [popoverStyle]="{ backgroundColor: 'white', color: '#1C53D9' }"
                                    [appendToBody]="true">
                                    <span class="color-grey">{{item.sectionCode}}</span> {{item.sectionName}}
                                </p>
                            </td>
                            <td class="{{isLM ? 'background-white border-bottom-black' : ''}}"
                                *ngIf="isLM && item.sectionCode || !isLM" [rowSpan]="item.sectionSpan ?? 1">
                                <format-data [contentStr]="item.projectTypeName ?? ''" [patternStr]="'E+134'">
                                </format-data>
                                <br>
                                <span class="color-grey">{{item.projectTypeCode}}</span>
                            </td>
                            <td class="color-light text-center {{isLM ? 'background-white border-bottom-black' : ''}}"
                                *ngIf="isLM && item.sectionCode || !isLM" [rowSpan]="item.sectionSpan ?? 1">
                                {{item.constructionOrgName}}
                            </td>

                            <td class="text-center {{isLM ? 'background-white border-bottom-black' : ''}}"
                                *ngIf="isLM && item.code" [rowSpan]="item.codeSpan ?? 1">
                                {{item.code}}
                            </td>
                            <td class="{{isLM ? 'background-white border-bottom-black border-right-black' : ''}}"
                                *ngIf="isLM && item.code" [rowSpan]="item.codeSpan ?? 1">
                                <p *ngIf="!!item.mileage" class="ellipsis" dPopover [content]="item.mileage"
                                    [trigger]="'hover'" [position]="['bottom','top', 'right',  'left']"
                                    [controlled]="item.mileage.length > 16"
                                    [popoverStyle]="{ backgroundColor: 'white', color: '#1C53D9' }"
                                    [appendToBody]="true">
                                    {{item.mileage}}
                                </p>
                            </td>
                            <td class="color-light {{isLM ? 'background-white border-bottom-black border-right-black' : ''}}"
                                *ngIf="isLM && item.code || !isLM" [rowSpan]="item.codeSpan ?? 1"
                                [style.textAlign]="'center'">
                                <span *ngIf="item.status" class="{{ProjectSectionUnitStatusColorMap[item.status]}}">
                                    {{ProjectSectionUnitStatusMap[item.status]}}
                                </span>
                            </td>
                            <td class="color-light {{isLM ? 'background-white border-bottom-black border-right-black' : ''}}"
                                *ngIf="isLM && item.code || !isLM" [rowSpan]="item.codeSpan ?? 1"
                                [style.textAlign]="'center'">
                                <span *ngIf="item.constructionFormCompleted" class="color-success">齐全</span>
                                <span *ngIf="!item.constructionFormCompleted" class="color-primary">
                                    {{item.constructionFormUploadedCount}}
                                </span>
                                <span *ngIf="!item.constructionFormCompleted" class="color-grey">
                                    /
                                </span>
                                <span *ngIf="!item.constructionFormCompleted">
                                    {{item.constructionFormCount}}
                                </span>
                            </td>
                            <td class="color-light {{isLM ? 'background-white border-bottom-black border-right-black' : ''}}"
                                *ngIf="isLM && item.code || !isLM" [rowSpan]="item.codeSpan ?? 1"
                                [style.textAlign]="'center'">
                                <span *ngIf="item.superviseRecordFormCompleted" class="color-success">齐全</span>
                                <span *ngIf="!item.superviseRecordFormCompleted" class="color-primary">
                                    {{item.superviseRecordFormUploadedCount}}
                                </span>
                                <span *ngIf="!item.superviseRecordFormCompleted" class="color-grey">
                                    /
                                </span>
                                <span *ngIf="!item.superviseRecordFormCompleted">
                                    {{item.superviseRecordFormCount}}
                                </span>
                            </td>
                            <td>
                                {{item.jgInspItemName}}
                            </td>
                            <td class="{{ProjectSectionUnitJgStatusColorMap[item.jgStatus!]}}"
                                [style.textAlign]="'center'">
                                {{ProjectSectionUnitJgStatusMap[item.jgStatus!]}}
                            </td>
                            <td [style.textAlign]="'center'">
                                <span (click)="sign(item.jgRfiWorkFlowKey!)" class="clickable"
                                    [style.color]="getColor(item.jgRfiStatus!)">
                                    {{item.jgRfiName}}
                                </span>
                            </td>
                            <td [style.textAlign]="'center'">
                                <span (click)="sign(item.jgHirWorkFlowKey!)" class="clickable color-primary">
                                    {{item.jgHirName}}
                                </span>
                            </td>
                            <td class="editable">
                                <format-data [contentStr]="item.comment?.toString() ?? ''" [patternStr]="'E+118'">
                                    <input type="text" [(ngModel)]="item.comment"
                                        (blur)="onBlur(item.id!, item.comment ?? '')" (click)="edit('comment' + index)"
                                        class="{{editing['comment' + index] ? '' : 'transparent'}}">
                                </format-data>
                            </td>
                        </tr>
                    </table>
                </div>
            </table-pro>
        </div>
    </nz-content>
    <nz-footer class="footer">
        <nz-pagination [nzPageIndex]="pager.pageIndex" [(nzPageSize)]="pager.pageSize"
            [nzPageSizeOptions]="pager.pageSizeOptions" [nzTotal]="pager.total" nzShowQuickJumper
            [nzShowSizeChanger]="true" [nzShowQuickJumper]="true" (nzPageIndexChange)="pageIndexChange($event)"
            (nzPageSizeChange)="pageSizeChange($event)">
        </nz-pagination>
    </nz-footer>
</nz-layout>